import { fromJS } from 'immutable';

import * as constants from 'actions/paymentMethods/constants';
import uiRecord from 'reducers/ui/records';

export const initialState = uiRecord();

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_PAYMENT_METHODS:
      return uiRecord({
        loader: true
      });

    case constants.GET_PAYMENT_METHODS_SUCCESS:
      return uiRecord();

    case constants.GET_PAYMENT_METHODS_ERROR:
      return uiRecord({
        error: fromJS(action.error)
      });

    default:
      return state;
  }
};
